import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../../shared/shared.module';
import { SharedMaterialModule } from 'app/shared/shared-material.module';
import { AdresaComponent } from './adresa/adresa.component';
import { KontaktComponent } from './kontakt/kontakt.component';
import { OrganizacionaStrukturaOrganaComponent } from './organizaciona-struktura-organa/organizaciona-struktura-organa.component';
import { TablesModule } from 'app/views/tables/tables.module';
import { GenericTreeComponent } from './generic-tree/generic-tree.component';
import { LazyGenericTreeComponent } from './lazy-generic-tree/lazy-generic-tree.component';

const components = [
  AdresaComponent,
  KontaktComponent,
  OrganizacionaStrukturaOrganaComponent,
  GenericTreeComponent,
  LazyGenericTreeComponent
];

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    SharedModule,
    SharedMaterialModule,
    TablesModule
  ],
  declarations: components,
  exports: components
})
export class SharedFeaturesComponentModule { }
